import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-moniepoint-notification',
  templateUrl: './moniepoint-notification.component.html',
  styleUrls: ['./moniepoint-notification.component.scss']
})
export class MoniepointNotificationComponent implements OnInit {

  constructor() { }
  @Input() title;
  @Input() message;
  @Input() closable:boolean;
  @Input() canPerformAction:boolean;
  @Input() date:any;
  @Input() notificationType:NotificationType;
  @Input() actionName:string;
  @Input() dismissButtonName:string;
  readonly TRANSPARENT_INFO_CLASS = "transparent-info-bg";
  readonly INFO_CLASS = "info-bg";
  readonly ERROR_CLASS = 'transparent-error-bg'
  readonly WARNING_CLASS = 'transparent-warning-bg'
  backgroundClass:string;
  readonly DEFAULT_ACTION_BTN_NAME = 'Continue';
  readonly DEFAULT_DISMISS_BTN_NAME = 'Dismiss';
  @Output() emitNotificationAction = new EventEmitter ();
  @Output() emitDismissal = new EventEmitter ();

  ngOnInit(): void {
    this.initialize();
  }

  getNotificationClass(type:NotificationType){
    switch (type){
      case "info":
       return  this.INFO_CLASS;
      case "transparent-info":
      return this.TRANSPARENT_INFO_CLASS;
      case "error":
      return this.ERROR_CLASS;
      case "warning":
        return  this.WARNING_CLASS;
      default:
      return this.INFO_CLASS;
    }
  }

  initialize(){
    this.backgroundClass = this.getNotificationClass(this.notificationType);
    if(this.canPerformAction){
      if(!this.actionName){
        this.actionName = this.DEFAULT_ACTION_BTN_NAME;
      }
    }

    if(this.closable){
      if(!this.dismissButtonName){
        this.dismissButtonName = this.DEFAULT_DISMISS_BTN_NAME;
      }
    }
  }

}

export type NotificationType = | 'transparent-info' | 'info'| 'error' | 'warning'
